<mainpanel
  *ngIf="loader$ | async as loader"
  [pageData]="pageData"
  [Title]="title$ | async"
  [hideSearchBox]="true"
  [hideSearchDropdown]="false"
  (onSubmit)="onFilterSearch(loader)"
>
  <div actions>
    <a
      class="btn btn-outline-secondary"
      (click)="onExport(loader)"
      ><i class="fa-solid fa-upload" aria-hidden="true"></i> Export</a
    >
  </div>
  <div filters>
  <div container>
    <div class="d-flex flex-column mb-5">
      <h6 class="mb-2">From - To</h6>
      <datepicker
        [isFloatingLabel]="false"
        placeholder="From"
        appearance="outline"
        [(date)]="loader.From"
      >
      </datepicker>
    </div>

    <div class="d-flex flex-column mb-5">
      <datepicker
        [isFloatingLabel]="false"
        placeholder="To"
        appearance="outline"
        [(date)]="loader.To"
      ></datepicker>
    </div>

    <div class="d-flex flex-column mb-5">
      <h6 class="mb-2">Page Size</h6>
      <input
        id="pageSize"
        type="number"
        [(ngModel)]="loader.PageSize"
        name="pageSize"
        min="1"
        class="form-control"
        style="height: 32px;"
      />
    </div>
  </div>
</div>

  <div content>
    <div class="container-fluid mt-5">
      <ng-container *ngIf="data$ | async as data">
        <div class="table-responsive">
          <table class="table"
          matSort (matSortChange)="sortData($event)"
          >
            <thead class="thead-light sticky-top-thead">
              <tr>
                <th style="width: 5px;">No</th>
                <th style="width: 250px;">Subdomain</th>
                <th class="text-end"
                mat-sort-header="Sales" arrowPosition="before"
                >Sales</th>
                <th class="text-end" mat-sort-header="Tax" arrowPosition="before">Tax</th>
                <th class="text-end" mat-sort-header="Cost" arrowPosition="before">Cost</th>
                <th class="text-end" mat-sort-header="InvoiceCount" arrowPosition="before">Orders</th>
                <th class="text-end" mat-sort-header="Quantity" arrowPosition="before">Quantity</th>
                <th class="text-end" mat-sort-header="Gross" arrowPosition="before">Gross</th>
                <th class="text-end" mat-sort-header="Profit" arrowPosition="before">Profit</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of data.Data; let i = index" class="border-bottom">
                <td>{{ i + 1 }}</td>
                <td>{{ item.Subdomain }}</td>
                <td class="text-end">{{ item.Sales | number }}</td>
                <td class="text-end">{{ item.Tax | number }}</td>
                <td class="text-end">{{ item.Cost | number }}</td>
                <td class="text-end">{{ item.InvoiceCount | number }}</td>
                <td class="text-end">{{ item.Quantity | number }}</td>
                <td class="text-end">{{ item.Gross ? (item.Gross | number) : 0 }}</td>
                <td class="text-end">{{ item.Profit | number }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="2" class="fw-bold">Total :</td>
                <td class="text-end fw-bold">{{ data.Total.Sales | number }}</td>
                <td class="text-end fw-bold">{{ data.Total.Tax | number }}</td>
                <td class="text-end fw-bold">{{ data.Total.Cost | number }}</td>
                <td class="text-end fw-bold">{{ data.Total.InvoiceCount | number }}</td>
                <td class="text-end fw-bold">{{ data.Total.Quantity | number }}</td>
                <td class="text-end fw-bold">{{ data.Total.Gross | number }}</td>
                <td class="text-end fw-bold">{{ data.Total.Profit | number }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </ng-container>

      <div class="mt-2">
        <POS-complex-pagination
          api="Report/ChannelCount"
          [total]="(data$ | async)?.Data?.length"
          [pageData]="loader$ | async"
          (jumpToPage)="paginationChange($event)"
          (previousPage)="paginationChange($event)"
          (nextPage)="paginationChange($event)"
        >
        </POS-complex-pagination>
      </div>
    </div>
  </div>
</mainpanel>
